import { AccountsManagementRepositoryImplementation } from '../infrastructure/accounts-management-repository-implementation';

import { cacheManager } from '../infrastructure/cache-manager';

const repo = new AccountsManagementRepositoryImplementation();
const CACHE_PREFIX = 'accounts_management';

async function getReceivableSummary(uid: string, cid: string | null, page = 1, limit = 20, query = "", forceReload = false) {
    const cacheKey = `${CACHE_PREFIX}-receivable-${uid}-${cid}-${page}-${limit}-${query}`;

    if (!forceReload) {
        const cached = cacheManager.getItem(cacheKey);
        if (cached) return cached;
    }

    const response = await repo.getReceivableSummary(uid, cid, page, limit, query).toPromise();
    const data = response.data;

    if (data) {
        cacheManager.setItem(cacheKey, data);
    }
    return data;
}

async function getPayableSummary(uid: string, cid: string | null, page = 1, limit = 20, query = "", forceReload = false) {
    const cacheKey = `${CACHE_PREFIX}-payable-${uid}-${cid}-${page}-${limit}-${query}`;

    if (!forceReload) {
        const cached = cacheManager.getItem(cacheKey);
        if (cached) return cached;
    }

    const response = await repo.getPayableSummary(uid, cid, page, limit, query).toPromise();
    const data = response.data;

    if (data) {
        cacheManager.setItem(cacheKey, data);
    }
    return data;
}

async function registerReceivablePayment(uid: string, cid: string | null, accountId: number, data: any) {
    const response = await repo.registerReceivablePayment(uid, cid, accountId, data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

async function registerPayablePayment(uid: string, cid: string | null, accountId: number, data: any) {
    const response = await repo.registerPayablePayment(uid, cid, accountId, data).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

export {
    getReceivableSummary,
    getPayableSummary,
    registerReceivablePayment,
    registerPayablePayment
};
